import { render, staticRenderFns } from "./packLogin.vue?vue&type=template&id=70e4d41d"
import script from "./packLogin.vue?vue&type=script&lang=js"
export * from "./packLogin.vue?vue&type=script&lang=js"
import style0 from "./packLogin.vue?vue&type=style&index=0&id=70e4d41d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports